module.exports = __webpack_public_path__ + "static/group-image-15e9ea71daf57afd7d0c02065d05d818.jpg";